import { getApiCall } from '../utils/Api';

const getCounts = async () => {
  const response = await getApiCall(`/overview/counts`);
  return response.data;
};

export default getCounts;
